module.exports = __webpack_public_path__ + "static/background_asnews_us-e5debaf601402c65007752f29cba700e.png";